// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1e8c4e74\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./slim.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("a2041166", content, true);


//////////////////
// WEBPACK FOOTER
// /~/vue-style-loader!/~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e8c4e74","scoped":false,"hasInlineConfig":false}!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/vendor/slim/slim.vue
// module id = 423
// module chunks = 0